// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoVideoPlaceholder__container-ee7e02 {
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/OpponentVideo/NoVideoPlaceholder/NoVideoPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".container {\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NoVideoPlaceholder__container-ee7e02`
};
module.exports = ___CSS_LOADER_EXPORT___;
